// Module
var code = "<!-- ko if: Mails().length !== 0 --> <ul class=\"dropdown-menu submenu\"> <!-- ko foreach: Mails --> <li> <a data-bind=\"click: $parent.SelectTemplate.bind($parent, $parent._currentHtmlTemplate(), $data)\" href=\"#\"> <!-- ko text: Login --><!-- /ko --> </a> </li> <!-- /ko --> </ul> <!-- /ko -->";
// Exports
export default code;